import { render, staticRenderFns } from "./addDocumetItem.vue?vue&type=template&id=221cd183&scoped=true&"
import script from "./addDocumetItem.vue?vue&type=script&lang=js&"
export * from "./addDocumetItem.vue?vue&type=script&lang=js&"
import style0 from "./addDocumetItem.vue?vue&type=style&index=0&id=221cd183&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221cd183",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('221cd183')) {
      api.createRecord('221cd183', component.options)
    } else {
      api.reload('221cd183', component.options)
    }
    module.hot.accept("./addDocumetItem.vue?vue&type=template&id=221cd183&scoped=true&", function () {
      api.rerender('221cd183', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chatbotManagement/components/addDocumetItem.vue"
export default component.exports